<template>
  <div>
    <div class="recommend-header">
      <div class="recommend-header-one">
        <img :src="img" @click="goBack()"/>
      </div>
      <div class="recommend-header-two">
        <span class="recommend-header-left" v-if="type==headType.recommendMain">全部推荐</span>
        <span class="recommend-header-left-share" v-if="type==headType.share || type==headType.wxDetail">商品详情</span>
        <span class="recommend-header-left" v-else>{{title}}</span>
      </div>
      <div class="recommend-header-three">
        <button class="recommend-header-right-main" v-if="type==headType.recommendMain" @click="goToH5Main()">返回首页</button>
        <!--<button class="recommend-header-right" v-else-if="type==headType.recommend" @click="goToMoreRecommend()">更多推荐 >></button>-->
      </div>
    </div>
  </div>
</template>
<script>
  export default{
    name:'ClassHeader',
    props:['title','type'],
    data(){
      return{
        img:require("../../../static/img/H5_home_black.png")
      }
    },
    created(){
      var newTitle = this.title ? this.title : "优惠活动";
      document.title = this.isWeixin ? newTitle : newTitle + "_一起买买买社交电商平台，yiqimmm.com天猫淘宝京东优惠券-一起买买买";
    },
    mounted(){
      if(this.isIos){
        try{
          document.getElementsByClassName("recommend-header-right")[0].style.lineHeight='2rem';
        }catch(e){

        }
      }
      let uid = this.$route.query.uid;
      if(uid){
        this.setCookie("uid",uid,365);
      }
      let unionId = this.$route.query.unionId;
      if(unionId){
        this.setCookie("unionId",unionId,365);
      }
    },
    methods:{
      goBack(){
        if(this.type==this.headType.wxDetail){
          this.jumpToView(this.headType.h5Main)
        }else{
          window.history.back();
        }
      },
      goToH5Main(){
        this.jumpToView(this.headType.h5Main)
      },
      goToMoreRecommend(){
        this.watcher.$emit("goToRecommend",this.headType.recommendMain);
      },
      setCookie(key, value, day) {
        let date = new Date();
        date.setDate(date.getDate() + day);
        document.cookie = key + '=' + encodeURI(value) + ';expires=' + date;
      }
    }
  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// ClassHeader.vue?1ca0d09c